import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { ChangelogSeenService } from '@app/core/state/changelogseen/changelogseen.service';
import { ClVersion } from '@app/shared/changelog/version/clversion.model';
import { KeyValue } from '@pezi/entities';
import { Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class ChangelogService extends RestService {
  clickedVersion = new Subject<number>();
  versionsAvailable = new Subject<boolean>();
  versionsChanged = new Subject<ClVersion[]>();

  private versions: ClVersion[] = [];

  constructor(protected http: HttpClient, private changelogSeen: ChangelogSeenService) {
    super(http);
  }

  getVersions(limit: number) {
    const params = this.getKeyValueAsQueryParams([
      {
        key: 'limit',
        value: limit
      } as KeyValue<string, number>
    ]);

    const options = Object.assign({}, this.httpOptions,
      {params});

    return this.http
      .get<ClVersion[]>(
        this.baseUrl + '/changelog', options).pipe(
        map(versions => versions.map(version => ({
              ...version,
              date: new Date(version.date),
              features: version.features ? version.features : []
            }))),
        tap(versions => {
          versions.forEach(version => version.seen =
              this.changelogSeen.isVersionSeen(version.title) || this.changelogSeen.isVersionOld(version, 60));
          this.setVersions(versions);
        })
      );
  }

  setVersions(versions: ClVersion[]) {
    this.versions = versions;
    this.versionsChanged.next(this.versions.slice());
    this.checkVersions(versions);
  }

  getFeatures(index: number) {
    return this.versions[index].features.slice();
  }

  checkVersions(versions: ClVersion[]) {
    this.versionsAvailable.next(this.changelogSeen.needsReading(versions));
  }
}
